import React, { useMemo } from 'react';
import InventoryMetaPage from '../components/inventory/InventoryMetaPage';

export default function CategoryPage() {
    const columns = useMemo(() => [
        {
            key: 'image',
            label: 'Image',
            render: (row) => row.metadata?.image_url
                ? <img src={row.metadata.image_url} alt={row.name} style={{ width: 34, height: 34, borderRadius: 8, objectFit: 'cover', border: '1px solid var(--line)' }} />
                : <span className="muted-cell">-</span>,
        },
        { key: 'name', label: 'Category' },
        { key: 'slug', label: 'Category Slug' },
        { key: 'usage_count', label: 'Products' },
        {
            key: 'created_at',
            label: 'Created On',
            render: (row) => new Date(row.created_at).toLocaleDateString(),
        },
        { key: 'status', label: 'Status' },
    ], []);

    return (
        <InventoryMetaPage
            title="Category"
            type="category"
            columns={columns}
            fields={[
                { name: 'name', label: 'Category Name' },
                { name: 'slug', label: 'Slug', placeholder: 'Auto from name if empty' },
                { name: 'image_url', label: 'Category Image', type: 'image', helpText: 'Upload an image or paste an image URL. This is shown on the public store.' },
                { name: 'description', label: 'Description', type: 'textarea' },
            ]}
            buildPayload={(form) => ({
                name: form.name,
                slug: form.slug,
                description: form.description,
                status: form.status,
                metadata: {
                    image_url: form.image_url || '',
                },
            })}
        />
    );
}
